export const DOCTOR_ROLE = 'doctor';
export const PATIENT_ROLE = 'patient';
export const SUPER_ADMIN_ROLE = 'superadmin';
